"use client";

import { Action, Core } from "@faire/slate/foundation/color";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Badge } from "@faire/web/slate/deprecated/Badge";
import { getSpacing } from "@faire/web/slate/spacing";
import { TypographyStyles } from "@faire/web/ui/Typography";
import * as React from "react";
import styled, { css } from "styled-components";

export const ShowroomBadge: React.FC<{
  className?: string;
  onMouseEnter?: () => void;
  small?: boolean;
}> = ({ className, onMouseEnter, small }) => {
  const { strictLocalize } = useStrictLocalization();

  return (
    <StyledBadge
      content={strictLocalize({
        id: "ZZiVOf",
        defaultMessage: "Showroom",
        description: { text: "Badge indicating this is a showroom product" },
      })}
      backgroundColor={Action.surface.active}
      contentColor={Core.text.primaryInverse}
      borderColor={Action.border.hover} // TODO select a non-hover border token; black not available
      className={className}
      onMouseEnter={onMouseEnter}
      smallSizeBadge={small}
      data-test-id="showroom-badge"
    />
  );
};

const StyledBadge = styled(Badge)<{
  smallSizeBadge?: boolean;
}>`
  ${({ smallSizeBadge }) =>
    TypographyStyles({
      weight: "medium",
      color: "white",
      small: smallSizeBadge,
    })};
  cursor: default;
  ${({ smallSizeBadge }) =>
    smallSizeBadge
      ? css`
          padding: ${getSpacing(3, 7)};
        `
      : css`
          padding: ${getSpacing(4, "1x")};
        `};

  border-radius: 4px;
`;
